import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.timeout = null
    if (this.hasInputTarget) {
      const len = this.inputTarget.value.length
      if (len > 0) {
        this.inputTarget.focus()
        this.inputTarget.setSelectionRange(len, len)
      }
    }
  }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const query = this.hasInputTarget ? this.inputTarget.value.trim() : ""
      const url = new URL(this.element.action || window.location.href)
      if (query) {
        url.searchParams.set("q", query)
      } else {
        url.searchParams.delete("q")
      }
      url.searchParams.delete("tab")
      url.searchParams.delete("page")
      history.replaceState({}, "", url.toString())
      this.element.requestSubmit()
    }, 300)
  }
}
